import type { ApiError } from '@porotutu/react/errors'

const QUOTED = /filename="([^"]*)"/
const ENCODED = /filename\*=UTF-8''([^;]+)/i

export const filenameOf = (disposition: string | null, fallback: string): string => {
  const encoded = ENCODED.exec(disposition ?? '')

  if (encoded !== null) {
    try {
      return decodeURIComponent(encoded[1])
    } catch {
      return encoded[1]
    }
  }

  const quoted = QUOTED.exec(disposition ?? '')

  return quoted === null || quoted[1] === '' ? fallback : quoted[1]
}

export const saveBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')

  anchor.href = url
  anchor.download = filename
  anchor.rel = 'noopener'
  document.body.append(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}

const bodyOf = async (response: Response): Promise<unknown> => {
  try {
    return await response.json()
  } catch {
    return null
  }
}

export async function downloadSheet(href: string, fallback: string): Promise<ApiError | null> {
  const response = await fetch(href, {
    credentials: 'same-origin',
    headers: { accept: '*/*' },
  })

  if (!response.ok) {
    return { status: response.status, value: await bodyOf(response) }
  }

  saveBlob(await response.blob(), filenameOf(response.headers.get('content-disposition'), fallback))

  return null
}
